import { useEffect, useState } from "react";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { PageHeader } from "@/components/StatusBits";
import { IntegrationsTab } from "@/components/settings/IntegrationsTab";
import { NumbersSection } from "@/components/settings/NumbersSection";
import { BusinessTab, ProfileTab, RulesTab, SmsTab, TeamTab } from "@/components/settings/SettingsTabs";
import { useApp } from "@/context/AppContext";
import { api } from "@/lib/api";

export default function Settings() {
  const { isAdmin, status } = useApp();
  const [settings, setSettings] = useState(null);
  useEffect(() => {
    api.get("/settings").then((r) => setSettings(r.data)).catch(() => {});
  }, []);
  return (
    <div className="max-w-7xl p-6 space-y-5">
      <PageHeader title="Settings" sub="Integrations, calling rules, texting, team and your profile." />
      <Tabs defaultValue={isAdmin ? "integrations" : "profile"}>
        <TabsList className="flex-wrap h-auto">
          <TabsTrigger value="integrations" data-testid="settings-tab-integrations">Integrations</TabsTrigger>
          {isAdmin && <TabsTrigger value="numbers" data-testid="settings-tab-numbers">Phone numbers</TabsTrigger>}
          <TabsTrigger value="rules" data-testid="settings-tab-rules">Calling rules</TabsTrigger>
          <TabsTrigger value="sms" data-testid="settings-tab-sms">Texting</TabsTrigger>
          <TabsTrigger value="business" data-testid="settings-tab-business">Business</TabsTrigger>
          {isAdmin && <TabsTrigger value="team" data-testid="settings-tab-team">Team</TabsTrigger>}
          <TabsTrigger value="profile" data-testid="settings-tab-profile">My profile</TabsTrigger>
        </TabsList>
        <TabsContent value="integrations" className="pt-3"><IntegrationsTab /></TabsContent>
        {isAdmin && (
          <TabsContent value="numbers" className="pt-3">
            <div className="bg-white border border-slate-200 rounded-lg p-5 max-w-4xl">
              {status?.twilio?.configured ? <NumbersSection /> : <p className="text-sm text-slate-500" data-testid="numbers-not-configured">Twilio: Not configured. Save your Twilio credentials in Integrations and your numbers will load here automatically.</p>}
            </div>
          </TabsContent>
        )}
        <TabsContent value="rules" className="pt-3">{settings && <RulesTab settings={settings} />}</TabsContent>
        <TabsContent value="sms" className="pt-3">{settings && <SmsTab settings={settings} />}</TabsContent>
        <TabsContent value="business" className="pt-3">{settings && <BusinessTab settings={settings} />}</TabsContent>
        {isAdmin && <TabsContent value="team" className="pt-3"><TeamTab /></TabsContent>}
        <TabsContent value="profile" className="pt-3"><ProfileTab /></TabsContent>
      </Tabs>
    </div>
  );
}
